import React, { useLayoutEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';

import { appDialogStore } from '../services/appDialogs';

import { ConfirmDialog } from './ConfirmDialog';

export function AppDialogHost() {
  const location = useLocation();
  const request = useSyncExternalStore(appDialogStore.subscribe, appDialogStore.getSnapshot, () => null);

  useLayoutEffect(() => appDialogStore.attach(), []);
  useLayoutEffect(() => () => appDialogStore.cancelPending(), [location.key]);

  return request ? <ConfirmDialog key={request.id} title={request.title} message={request.message}
    confirmLabel={request.confirmLabel} cancelLabel={request.cancelLabel} confirmVariant={request.confirmVariant}
    hideCancel={request.kind === 'alert'} onConfirm={() => appDialogStore.answer(request.id, true)}
    onCancel={() => appDialogStore.answer(request.id, false)} /> : null;
}
